import "./contact-me.css";
import { useForm } from "@formspree/react";
import { Row, Col } from "react-bootstrap";
import Heading from "../../heading/Heading";

const ContactMe = () => {
  const [state, handleSubmit] = useForm("mdorwjgw");

  if (state.succeeded) {
    return (
      <div className="contact-me" id="contact">
        <Row>
          <Col lg={8} md={8} sm={12}>
            <div className="contact-form-div message d-flex justify-content-lg-start justify-content-md-start justify-content-sm-center justify-content-center align-items-center">
              <Heading word="Message Has Sent!" headingSize="h1" />
            </div>
          </Col>
          <Col lg={4} md={4} sm={12}>
            <div className="contact-info d-flex flex-column align-items-lg-end align-items-md-end align-items-sm-center justify-content-lg-between justify-content-md-between justify-content-sm-center">
              <div className="footer-brand d-lg-flex d-md-flex d-sm-none d-none justify-content-start align-items-center">
                <h1>
                  <span>{"<N/>"}</span> Nika Gogelia
                </h1>
              </div>
              <ul className="contact-info-bio">
                <li className="text-lg-end text-md-end text-sm-center text-center">
                  <strong>Address</strong>: Tbilisi, Georgia
                </li>
                <li className="text-lg-end text-md-end text-sm-center text-center">
                  <strong>Email</strong>: gogelianika1@gmail.com
                </li>
              </ul>
            </div>
          </Col>
          <Col lg={12} md={12} sm={12}>
            <p className="copyrights">
              &copy;&nbsp;2023, Nika Gogelia. All rights reserved.
            </p>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className="contact-me" id="contact">
      <Row>
        <Col lg={8} md={8} sm={12}>
          <div className="contact-form-div d-flex flex-column align-items-lg-start align-items-md-start align-items-sm-center align-items-center justify-content-center">
            <Heading word="Contact Me" headingSize="h1" />
            <p>
              My inbox is always open. Whether you have a question or project or
              just want to say hi, I'll try my best to get back to you
            </p>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="d-flex">
                <div className="input-container d-flex flex-column justify-content-center">
                  <input
                    type="text"
                    name="first-name"
                    id="firstname"
                    placeholder="FirstName"
                  />
                </div>
                <div className="input-container d-flex flex-column justify-content-center">
                  <input
                    type="text"
                    name="last-name"
                    id="lastname"
                    placeholder="LastName"
                  />
                </div>
              </div>
              <div className="input-container d-flex flex-column justify-content-center">
                <input
                  required={true}
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email"
                />
              </div>
              <div className="input-container d-flex flex-column justify-content-center">
                <textarea
                  required={true}
                  name="message"
                  id="message"
                  cols="50"
                  rows="10"
                  maxLength={300}
                  placeholder="Message"
                ></textarea>
              </div>
              <button
                className="button form-button"
                type="submit"
                name="submit"
                disabled={state.submitting}
              >
                Submit
              </button>
            </form>
          </div>
        </Col>
        <Col lg={4} md={4} sm={12}>
          <div className="contact-info d-flex flex-column align-items-lg-end align-items-md-end align-items-sm-center justify-content-lg-between justify-content-md-between justify-content-sm-center">
            <div className="footer-brand d-lg-flex d-md-flex d-sm-none d-none justify-content-start align-items-center">
              <h1>
                <span>{"<N/>"}</span> Nika Gogelia
              </h1>
            </div>
            <ul className="contact-info-bio">
              <li className="text-lg-end text-md-end text-sm-center text-center">
                <strong>Address</strong>: Tbilisi, Georgia
              </li>
              <li className="text-lg-end text-md-end text-sm-center text-center">
                <strong>Email</strong>: gogelianika1@gmail.com
              </li>
            </ul>
          </div>
        </Col>
        <Col lg={12} md={12} sm={12}>
          <p className="copyrights">
            &copy;&nbsp;2023, Nika Gogelia. All rights reserved.
          </p>
        </Col>
      </Row>
    </div>
  );
};

export default ContactMe;
